import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  ListGroup,
} from "react-bootstrap";
import { FaCommentDots } from "react-icons/fa";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  getDisciplinaryCases,
  saveDisciplinaryCase,
  editDisciplinaryCase,
  deleteDisciplinaryCase,
} from "../../../redux/Modulo_Sanciones/diciplinarycase/actions";
import {
  getResponsables,
  getResponsablesOtro,
} from "../../../redux/climalaboral/campaña/action";
import { getAllActiveEmployees } from "../../../redux/employees/actions";
import { getDisciplinaryActionTypes } from "../../../redux/Modulo_Sanciones/Disciplinary_Action_Types/actions";
import { getDisciplinaryAction } from "../../../redux/Modulo_Sanciones/Disciplinary_Reason/actions";
import { getFoulType } from "../../../redux/Modulo_Sanciones/Foul_Type/actions";
import { getStatuss } from "../../../redux/Modulo_Sanciones/status/actions";
import {
  getComments,
  postComment,
  resetComments,
} from "../../../redux/Modulo_Sanciones/diciplinarycase/actions";
import "./DisciplinaryCase.css";
import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";
// import SidebarBoarding from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";
import SidebarBoarding from "../../../components/SidebarDashboard";
import { getWorkflows } from "../../../redux/on&offBoarning/workflow/actions";
import { getUnlinkCategories } from "../../../redux/Modulo_Sanciones/Unlink_Categories/actions";
import { getUsers, resetListUsers } from "../../../redux/auth/actions";
import LinkDescargaArchive from "../../../components/Modulo_Sanciones/LinkDescargaArchive";
import { getRecidivismEmployee } from "../../../redux/Modulo_Sanciones/Recidivism/actions";
import toastr from "toastr";

const filters = [
  { id: "caso_disciplinario", desc: "Caso disciplinario" },
  { id: "creado_por", desc: "Creado por" },
  { id: "descripcion", desc: "Descripción" },
  { id: "empleado", desc: "Empleado" },
  { id: "encargado", desc: "Encargado" },
  { id: "empleado__zona", desc: "Zona" },
  {
    id: "empleado__empresa",
    desc: "Empresa",
    authorized_roles: ["administrador"],
  },
  { id: "estatus", desc: "Estatus" },
];

const filtersEmployees = [
  { id: "codigo", desc: "Codigo" },
  { id: "nombre", desc: "Nombre" },
];

const Disciplinary_Case = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [validatedEmployee, setValidatedEmployee] = useState(false);
  const [show, setShow] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);
  const [tipoBusquedaEmployee, setTipoBusquedaEmployee] = useState(
    filtersEmployees[0]
  );
  const [respOtroSelected, setRespOtroSelected] = useState([]);
  const [tempSelected, setTempSelected] = useState([]);
  const [catSelected, setCatSelected] = useState([]);
  const [showModalUser, setShowModalUser] = useState(false);

  //
  const [download, setDownload] = useState(null);
  const [downloadEdit, setDownloadEdit] = useState(null);
  //
  const [respSelected, setRespSelected] = useState([]);
  const [actionSelected, setActionSelected] = useState([]);
  const [motiveSelected, setMotiveSelected] = useState([]);
  const [userSelected, setUserSelected] = useState(null);

  const [view, setView] = useState("");
  const [showComments, setShowComments] = useState(false);
  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    // caso_disciplinario: Yup.string()
    //   .matches(/[\w]/, "Formato no correcto")
    //   .required("**Campo requerido"),
    caso_disciplinario: Yup.string().when("edit", {
      is: () =>
        !editItem ||
        (editItem && !editItem.list_sanciones_casos_disciplinarios_archivos),
      then: Yup.string().required("**Campo requerido"),
    }),
    id_accion_disciplinaria: Yup.string()
      .ensure()
      .required("**Campo requerido"),
    id_motivo: Yup.string().ensure().required("**Campo requerido"),
    id_encargado: Yup.string().ensure().required("**Campo requerido"),
    id_tipo_falta: Yup.string().ensure().required("**Campo requerido"),
    codigo_empleado: Yup.string().required("**Campo requerido"),
    descripcion: Yup.string()
      .matches(/[\w]/, "Formato no correcto")
      .required("**Campo requerido"),
    fecha_vencimiento: Yup.string().required("**Campo requerido"),
    estatus: Yup.string().required("**Campo requerido"),
    numero_ticket: Yup.string().notRequired(),
    id_workflow: Yup.string().nullable().notRequired(),
    id_responsable_off: Yup.string().nullable().notRequired(),
    categoria_desvinculacion: Yup.string().nullable().notRequired(),
    comentarios: Yup.string().notRequired(),
  });

  const { userId, username } = useSelector((store) => store.auth);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const { employees, employeesFaild, loaderAllEmployees } = useSelector(
    (store) => store.employees
  );
  const data = useSelector((store) => store.auth.users);
  const { loadingAuth } = useSelector((store) => store.auth);
  const {
    loaderDiciplinaryCases,
    saveLoaderDiciplinaryCase,
    disciplinaryCases,
    disciplinaryCasesFaild,
    formDisciplinaryCaseFaild,
  } = useSelector((store) => store.disciplinaryCase);
  const {
    responsable,
    responsableLoading,
    responsablesOtro,
    responsablesOtroLoading,
  } = useSelector((store) => store.campaña);
  const loadingFoulType = useSelector((store) => store.foulType.loading);
  const { foulType, foulTypeError } = useSelector((store) => store.foulType);
  const loadingDisciplinaryAction = useSelector(
    (store) => store.disciplinaryActions.loading
  );
  const { disciplinaryAction, disciplinaryActionError } = useSelector(
    (store) => store.disciplinaryReason
  );
  const loadingDisciplinaryActionType = useSelector(
    (store) => store.disciplinaryActionType.loading
  );
  const { disciplinaryActionTypes, disciplinaryActionTypesError } = useSelector(
    (store) => store.disciplinaryActionType
  );
  const { loaderStatuss, statuss, statussFaild } = useSelector(
    (store) => store.sancionesStatus
  );
  const { workflows } = useSelector((store) => store.workflow);
  const loadingWorkFlow = useSelector((store) => store.workflow.loading);
  const { unlinkCategories } = useSelector((store) => store.unlinkCategories);
  const loadingUnlinkCategories = useSelector(
    (store) => store.unlinkCategories.loading
  );
  const pages = Math.ceil(
    (disciplinaryCases ? disciplinaryCases.count : 0) / limit
  );
  const { comments } = useSelector((store) => store.disciplinaryCase);

  let responsableOptions = [];
  responsable &&
    responsable.map(
      (user) =>
        (responsableOptions = [
          ...responsableOptions,
          {
            id: user.id,
            label: `${user.username}-${user.first_name} ${user.last_name}`,
          },
        ])
    );
  let actioTypeOptions = [];
  disciplinaryActionTypes &&
    disciplinaryActionTypes
      .sort((a, b) =>
        a.descripcion && b.descripcion && a.descripcion > b.descripcion
          ? 1
          : a.descripcion && b.descripcion && b.descripcion > a.descripcion
          ? -1
          : 0
      )
      .map(
        (act) =>
          (actioTypeOptions = [
            ...actioTypeOptions,
            {
              id: act.id,
              label: act.descripcion ? act.descripcion : "",
            },
          ])
      );
  let motiveOptions = [];
  disciplinaryAction &&
    disciplinaryAction
      .sort((a, b) =>
        a.nombre && b.nombre && a.nombre > b.nombre
          ? 1
          : a.nombre && b.nombre && b.nombre > a.nombre
          ? -1
          : 0
      )
      .map(
        (act) =>
          (motiveOptions = [
            ...motiveOptions,
            {
              id: act.id,
              label: act.nombre ? act.nombre : "",
            },
          ])
      );
  let templateOptions = [];
  workflows &&
    workflows.map((template) => {
      if (parseInt(template.tipo_workflow) === 3) {
        templateOptions = [
          ...templateOptions,
          {
            id: template.id,
            label: `${template.nombre}`,
          },
        ];
      }
    });
  let responsableBoardingOptions = [];
  responsablesOtro &&
    responsablesOtro.map(
      (user) =>
        (responsableBoardingOptions = [
          ...responsableBoardingOptions,
          {
            id: user.id,
            label: `${user.username}-${user.first_name} ${user.last_name}`,
          },
        ])
    );
  let categoryOptions = [];
  unlinkCategories &&
    unlinkCategories.map((categ) => {
      categoryOptions = [
        ...categoryOptions,
        {
          id: categ.id,
          label: `${categ.nombre}`,
        },
      ];
    });
  const columns = [
    {
      Header: "Caso disciplinario",
      accessor: "caso_disciplinario",
      Filter: "",
    },
    {
      id: "motivo_disciplinario",
      Header: "Motivo del caso",
      Cell: (value) => value.row.original.list_id_motivo[0].nombre,
    },
    {
      Header: "Descripcion",
      accessor: "descripcion",
      Filter: "",
    },
    {
      id: "creadoPor",
      Header: "Creado por",
      Cell: (value) => (
        <div>
          {value.row.original.list_creado_por &&
          value.row.original.list_creado_por.length > 0
            ? `${value.row.original.list_creado_por[0].first_name} ${value.row.original.list_creado_por[0].last_name}`
            : "No se encontro creador"}
        </div>
      ),
    },
    {
      Header: "Fecha de vencimiento",
      accessor: "fecha_vencimiento",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_vencimiento).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "status",
      Header: "Estatus",
      Cell: (value) => (
        <div
          className="p-2 rounded-pill text-white text-center"
          style={{
            backgroundColor: value.row.original.list_estatus[0].color_a_mostrar,
            minWidth: "90px",
          }}
        >
          {value.row.original.list_estatus[0].nombre}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      Header: "Fecha cierre",
      accessor: "fecha_cierre",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.fecha_cierre
            ? moment(value.row.original.fecha_cierre).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          {view === "Responsable_Sanciones" ||
          view === "Encargado_Sanciones" ||
          view === "administrador" ? (
            // userRoles.length > 0 &&
            //   (userRoles.includes("Responsable_Sanciones") ||
            //     userRoles.includes("Encargado_Sanciones") ||
            //     userRoles.includes("administrador"))
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          ) : null}

          <LinkDescargaArchive id={value.row.original.id} />
          {value.row.original.list_sanciones_casos_disciplinarios_archivos &&
            value.row.original.list_sanciones_casos_disciplinarios_archivos
              .length > 0 && (
              <>
                {value.row.original.list_sanciones_casos_disciplinarios_archivos.map(
                  (url) => (
                    <>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>
                            Descargar {url.nombre_archivo}
                          </Tooltip>
                        }
                      >
                        <Button
                          size="sm"
                          className="text-secondary"
                          variant="link"
                          type="button"
                          disabled={
                            download !== null &&
                            parseInt(download) === parseInt(value.row.index)
                          }
                          onClick={() => {
                            setDownload(parseInt(value.row.index));
                            setTimeout(() => {
                              var element = document.createElement("a");
                              element.setAttribute(
                                "href",
                                // "data:text/plain;charset=utf-8," +
                                // encodeURIComponent(
                                `${process.env.REACT_APP_URL}/media/${url.archivo}`
                                // )
                              );
                              element.setAttribute(
                                "download",
                                `${url.nombre_archivo}`
                              );
                              element.style.display = "none";
                              document.body.appendChild(element);
                              element.click();
                              document.body.removeChild(element);
                              setDownload(null);
                            }, 500);
                          }}
                        >
                          {download !== null &&
                          parseInt(download) === parseInt(value.row.index) ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            <i className="material-icons">plagiarism</i>
                          )}
                        </Button>
                      </OverlayTrigger>
                    </>
                  )
                )}
              </>
            )}
        </div>
      ),
    },
  ];

  // Métodos
  const _getDisciplinaryCases = (
    offs = offset,
    lim = limit,
    tipo = tipoBusqueda.id,
    filt = filter,
    viw = view
  ) =>
    dispatch(
      getDisciplinaryCases({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipo,
        filter: filt,
        vista: viw,
      })
    );

  useEffect(() => {
    dispatch(
      getResponsablesOtro({ rol_responsable: "Responsable_OffBoarding" })
    );
    //dispatch(getAllEmployees());
    dispatch(getFoulType({}));
    dispatch(getDisciplinaryAction({}));
    // dispatch(getDisciplinaryActionTypes({}));
    dispatch(getStatuss({}));
    dispatch(getWorkflows({}));
    dispatch(getUnlinkCategories({}));
  }, []);

  useEffect(() => {
    let filters = {
      rol_responsable: "Encargado_Sanciones",
    };
    if (
      userRoles.includes("Encargado_Sanciones") ||
      userRoles.includes("Responsable_Sanciones")
    ) {
      filters.usuario_x_empresa = "si";
    }
    dispatch(getResponsables(filters));
  }, [userRoles]);

  useEffect(() => {
    if (userRoles.length > 0) {
      const rolActual = userRoles.filter(
        (usr) =>
          usr === "jefe" ||
          usr === "administrador" ||
          usr === "Responsable_Sanciones" ||
          usr === "Encargado_Sanciones" ||
          usr === "alta_direccion"
      )[0];
      setView(rolActual);
      _getDisciplinaryCases(offset, limit, tipoBusqueda.id, filter, rolActual);
      if (rolActual === "jefe" || rolActual === "alta_direccion") {
        // _getDisciplinaryCases(
        //   offset,
        //   limit,
        //   "jefe",
        //   {
        //     tipo_busqueda: tipoBusqueda.id,
        //     filter: filter,
        //   },
        //   rolActual
        // );
        dispatch(
          getDisciplinaryActionTypes({
            tipo_busqueda: "mostrar_jefe",
            filter: "True",
          })
        );
      } else {
        // _getDisciplinaryCases();
        dispatch(getDisciplinaryActionTypes({}));
      }
    }
  }, [userRoles]);

  // useEffect(() => {
  //   if (userRoles.length > 0) {
  //     if (
  //       userRoles.includes("jefe") ||
  //       (userRoles.includes("alta_direccion") &&
  //         !(
  //           userRoles.includes("Responsable_Sanciones") ||
  //           userRoles.includes("Encargado_Sanciones") ||
  //           userRoles.includes("administrador")
  //         ))
  //     ) {
  //       _getDisciplinaryCases(offset, limit, "jefe", {
  //         tipo_busqueda: tipoBusqueda.id,
  //         filter: filter,
  //       });
  //       dispatch(
  //         getDisciplinaryActionTypes({
  //           tipo_busqueda: "mostrar_jefe",
  //           filter: "True",
  //         })
  //       );
  //     } else {
  //       _getDisciplinaryCases();
  //       dispatch(getDisciplinaryActionTypes({}));
  //     }
  //   }
  // }, [userRoles]);

  const onAdd = () => {
    setRespOtroSelected([]);
    setTempSelected([]);
    setCatSelected([]);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
    setValidatedEmployee(false);
    setRespSelected([]);
    setUserSelected(null);
    dispatch(resetListUsers({}));
  };

  const onEdit = async (item, index) => {
    dispatch(resetComments());
    await dispatch(getComments(item.id));

    if (item.list_accion_disciplinaria) {
      setActionSelected([
        {
          id: item.list_accion_disciplinaria[0].id,
          label: item.list_accion_disciplinaria[0].descripcion
            ? item.list_accion_disciplinaria[0].descripcion
            : "",
        },
      ]);
    } else {
      setActionSelected([]);
    }
    if (item.list_id_motivo) {
      setMotiveSelected([
        {
          id: item.list_id_motivo[0].id,
          label: item.list_id_motivo[0].nombre
            ? item.list_id_motivo[0].nombre
            : "",
        },
      ]);
    } else {
      setMotiveSelected([]);
    }
    if (item.list_categoria_desvinculacion) {
      setCatSelected([
        {
          id: item.list_categoria_desvinculacion[0].id,
          label: item.list_categoria_desvinculacion[0].nombre,
        },
      ]);
    } else {
      setCatSelected([]);
    }
    if (item.list_id_usuario) {
      dispatch(getUsers({ filter: item.list_id_usuario[0].username }));
    }
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
    setValidatedEmployee(false);
    setRespSelected([
      {
        id: item.list_id_encargado[0].id,
        label: `${item.list_id_encargado[0].username}-${item.list_id_encargado[0].first_name} ${item.list_id_encargado[0].last_name}`,
      },
    ]);
    //setUserSelected([{id: item.list_codigo_empleado[0].id, label: `${item.list_codigo_empleado[0].codigo}-${item.list_codigo_empleado[0].nombre}`}]);
    setUserSelected({
      codigo: item.list_codigo_empleado[0].codigo,
      nombre: item.list_codigo_empleado[0].nombre,
    });
  };

  const onSearchRole = (e) => {
    e.preventDefault();
    setView(e.currentTarget.value);
    setFilter("");
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDisciplinaryCases(
      oOffset,
      limit,
      tipoBusqueda.id,
      filter,
      e.currentTarget.value
    );
    if (
      e.currentTarget.value === "jefe" ||
      e.currentTarget.value === "alta_direccion"
    ) {
      dispatch(
        getDisciplinaryActionTypes({
          tipo_busqueda: "mostrar_jefe",
          filter: "True",
        })
      );
    } else {
      // _getDisciplinaryCases();
      dispatch(getDisciplinaryActionTypes({}));
    }
    // if (
    //   e.currentTarget.value === "jefe" ||
    //   e.currentTarget.value === "alta_direccion"
    // ) {
    //   _getDisciplinaryCases(
    //     offset,
    //     limit,
    //     "jefe",
    //     {
    //       tipo_busqueda: tipoBusqueda.id,
    //       filter: filter,
    //     },
    //     e.currentTarget.value
    //   );
    // } else {
    //   _getDisciplinaryCases(
    //     oOffset,
    //     limit,
    //     tipoBusqueda.id,
    //     filter,
    //     e.currentTarget.value
    //   );
    // }
  };

  const onSearchState = (e) => {
    e.preventDefault();
    setFilter(e.currentTarget.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDisciplinaryCases(
      offset,
      limit,
      tipoBusqueda.id,
      e.currentTarget.value,
      view
    );
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDisciplinaryCases(
      offset,
      limit,
      tipoBusqueda.id,
      e.target.filter.value,
      view
    );
  };

  const onSubmit = async (req) => {
    const _estatus = statuss.data.find(
      (est) => parseInt(est.id) === parseInt(req.estatus)
    );

    if (_estatus.nombre.toLowerCase() === "cerrado") {
      const fecha = {
        fecha_cierre: moment(new Date()).format("YYYY-MM-DD"),
      };
      req = Object.assign(req, fecha);
    } else {
      const fecha2 = {
        fecha_cierre: null,
      };
      req = Object.assign(req, fecha2);
    }

    // Extraer el comentario del objeto `req` antes de guardar o editar el caso
    const comentario = req.comentarios;
    delete req.comentarios; // Eliminar el campo `comentarios` del objeto `req`

    if (!edit) {
      // Guardar el caso disciplinario y obtener el ID del caso creado
      const casoId = await dispatch(
        saveDisciplinaryCase(
          req, // Aquí `req` ya no incluye el campo `comentarios`
          setShowModal,
          _estatus,
          document.getElementById("archivo").files,
          _getDisciplinaryCases
        )
      );

      // Si el caso se creó correctamente, crear el comentario
      if (casoId && comentario) {
        const comentarioData = {
          caso_disciplinario: casoId,
          usuario: username, // Usuario autenticado
          comentario: comentario, // Comentario extraído del formulario
        };

        // Despachar la acción para crear el comentario
        await dispatch(postComment(comentarioData));
        dispatch(getComments(casoId));
      }
    } else {
      // En modo edición, primero editar el caso disciplinario
      await dispatch(
        editDisciplinaryCase(
          req,
          editItem,
          index,
          setShowModal,
          _estatus,
          document.getElementById("archivo").files,
          _getDisciplinaryCases
        )
      );

      // Si el caso se editó correctamente y hay un comentario, crear el comentario
      if (comentario) {
        const comentarioData = {
          caso_disciplinario: editItem.id, // Usar el ID del caso que se está editando
          usuario: username, // Usuario autenticado
          comentario: comentario, // Comentario extraído del formulario
        };

        // Despachar la acción para crear el comentario
        await dispatch(postComment(comentarioData));
        dispatch(getComments(editItem.id));
      }
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDisciplinaryCases(offset, limit, tipoBusqueda.id, oSearch, view);
    // if (
    //   view === "jefe" ||
    //   view === "alta_direccion"
    //   // userRoles.length > 0 &&
    //   // userRoles.includes("jefe") &&
    //   // !(
    //   //   userRoles.includes("Responsable_Sanciones") ||
    //   //   userRoles.includes("Encargado_Sanciones") ||
    //   //   userRoles.includes("administrador")
    //   // )
    // ) {
    //   _getDisciplinaryCases(
    //     offset,
    //     limit,
    //     "jefe",
    //     {
    //       tipo_busqueda: tipoBusqueda.id,
    //       filter: oSearch,
    //     },
    //     view
    //   );
    // } else {
    //   _getDisciplinaryCases(oOffset, limit, tipoBusqueda.id, oSearch, view);
    // }
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteDisciplinaryCase(id, index));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  const handleUserAdd = async (employee, setFieldValue, numero_ticket) => {
    setFieldValue("codigo_empleado", employee.id);
    setFieldValue(
      "numero_ticket",
      numero_ticket
        ? numero_ticket + employee.codigo
        : obtenerTextoCDT() + employee.codigo
    );

    try {
      const response = await getRecidivismEmployee(employee.codigo);

      if (response?.cantidad_casos_disciplinarios > 0) {
        toastr.info(`${response.mensaje}`);
      }
    } catch (error) {
      console.error("Error al obtener los casos disciplinarios:", error);
    }

    setUserSelected(employee);
    setShowModalUser(false);
  };

  const onSearchEmployee = (e) => {
    //e.preventDefault();
    if (e.key === "Enter") {
      if (!e.target.value.trim()) {
        setValidatedEmployee(true);
      } else {
        setValidatedEmployee(false);
        dispatch(
          getAllActiveEmployees({
            tipo_busqueda: tipoBusquedaEmployee.id,
            filter: e.target.value,
            vista: view,
          })
        );
      }
    }
  };

  const getEndDate = () => {
    let date = new Date();
    date.setDate(date.getDate() + 30);
    return date.toJSON().slice(0, 10);
  };

  // useEffect(() => {
  //   generarCodigo();
  // }, )

  // const generarCodigo = (id) => {
  //  const numeroTiecketG = "CDT" + id;
  //   // console.log("codigo de tiecket",numeroTiecketG)
  //   return numeroTiecketG;
  // }
  function obtenerTextoCDT() {
    // Obtener la fecha y hora actual
    var fecha = new Date();

    // Obtener los componentes de la fecha y hora
    var año = fecha.getFullYear();
    var mes = agregarCeros(fecha.getMonth() + 1);
    var dia = agregarCeros(fecha.getDate());
    var horas = agregarCeros(fecha.getHours());
    var minutos = agregarCeros(fecha.getMinutes());
    var segundos = agregarCeros(fecha.getSeconds());

    // Crear el texto con el formato deseado
    var textoCDT = "CD" + año + mes + dia + horas + minutos + segundos;

    return textoCDT;
  }

  function agregarCeros(numero) {
    if (numero < 10) {
      return "0" + numero;
    }
    return numero;
  }

  const ComentariosList = ({ comentarios }) => {
    return (
      <ListGroup className="mt-3">
        {comentarios.map((comentario) => (
          <ListGroup.Item key={comentario.id} className="comment-item">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <strong>{comentario.usuario.nombre_completo}</strong>
                <p className="mb-0">{comentario.comentario}</p>
              </div>
              <small className="text-muted">
                {moment(comentario.fecha_creacion).format("DD/MM/YYYY HH:mm")}
              </small>
            </div>
          </ListGroup.Item>
        ))}
      </ListGroup>
    );
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarBoarding show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Casos disciplinarios
            </h6>
            {/* {userRoles.length > 0 &&
              (userRoles.includes("Responsable_Sanciones") ||
                userRoles.includes("Encargado_Sanciones") ||
                userRoles.includes("administrador")) && ( */}
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  {tipoBusqueda.id === "estatus" ? (
                    <Form.Control
                      as="select"
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      onChange={onSearchState}
                      style={{ minWidth: "174px" }}
                    >
                      <option className="text-muted" key={0} value=""></option>
                      {statuss && statuss.data.length > 0
                        ? statuss.data.map((item) => (
                            <option key={item.nombre} value={item.nombre}>
                              {item.nombre}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                  ) : (
                    <Form.Control
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      type="search"
                    ></Form.Control>
                  )}
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <ButtonGroup>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                        }
                      >
                        <Dropdown className="ml-3 mr-3">
                          <Dropdown.Toggle
                            variant="light"
                            className="btn-sm font rounded-pill"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => {
                              const tieneAcceso =
                                !item.authorized_roles ||
                                item.authorized_roles.some((rol) =>
                                  userRoles.includes(rol)
                                );

                              return tieneAcceso ? (
                                <Dropdown.Item
                                  onClick={() => setTipoBusqueda(item)}
                                  key={item.id}
                                >
                                  {item.desc}
                                </Dropdown.Item>
                              ) : null;
                            })}
                          </Dropdown.Menu>
                        </Dropdown>
                      </OverlayTrigger>
                    </ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
            {/* )} */}
          </div>
          <Row className="mx-2 px-1 justify-content-start align-items-center flex-nowrap">
            {userRoles.filter(
              (usr) =>
                usr === "jefe" ||
                usr === "administrador" ||
                usr === "Responsable_Sanciones" ||
                usr === "Encargado_Sanciones" ||
                usr === "alta_direccion"
            ).length > 1 ? (
              <>
                <Col xs="auto">
                  <h6>
                    <b>Ver como:</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  {/* loadingAuth, users */}
                  <Form.Control
                    as="select"
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    onChange={onSearchRole}
                    style={{ minWidth: "174px" }}
                  >
                    {userRoles
                      .filter(
                        (usr) =>
                          usr === "jefe" ||
                          usr === "administrador" ||
                          usr === "Responsable_Sanciones" ||
                          usr === "Encargado_Sanciones" ||
                          usr === "alta_direccion"
                      )
                      .map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                  </Form.Control>
                </Col>
              </>
            ) : null}
          </Row>
          {disciplinaryCasesFaild && (
            <Alert variant="danger" className="my-4">
              {disciplinaryCasesFaild}
            </Alert>
          )}
          {statussFaild && (
            <Alert variant="danger" className="my-4">
              {statussFaild}
            </Alert>
          )}
          {foulTypeError !== "" ? (
            <Alert variant="danger" className="my-4">
              {foulTypeError}
            </Alert>
          ) : null}
          {disciplinaryActionError !== "" ? (
            <Alert variant="danger" className="my-4">
              {disciplinaryActionError}
            </Alert>
          ) : null}
          {disciplinaryActionTypesError !== "" ? (
            <Alert variant="danger" className="my-4">
              {disciplinaryActionTypesError}
            </Alert>
          ) : null}

          {loaderDiciplinaryCases ? (
            <div className="d-flex justify-content-center mt-4">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : disciplinaryCases && disciplinaryCases.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={columns}
                    data={disciplinaryCases.data}
                  />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={disciplinaryCases.count}
                pages={pages}
                pagFunc={_getDisciplinaryCases}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              {view === "jefe" || view === "alta_direccion"
                ? // userRoles.length > 0 &&
                  // userRoles.includes("jefe") &&
                  // !(
                  //   userRoles.includes("Responsable_Sanciones") ||
                  //   userRoles.includes("Encargado_Sanciones") ||
                  //   userRoles.includes("administrador")
                  // )
                  "Sin registros que mostrar, contacte al administrador."
                : "Sin registros que mostrar, comienza agregando algunos."}
            </Alert>
          )}
        </Container>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          dispatch(resetComments());
        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            caso_disciplinario: edit ? editItem.caso_disciplinario : "",
            id_accion_disciplinaria: edit
              ? editItem.id_accion_disciplinaria
              : "",
            id_motivo: edit ? editItem.id_motivo : "",
            id_encargado: edit ? editItem.id_encargado : "",
            id_tipo_falta: edit ? editItem.id_tipo_falta : "",
            codigo_empleado: edit ? editItem.codigo_empleado : "",
            descripcion: edit ? editItem.descripcion : "",
            fecha_vencimiento: edit ? editItem.fecha_vencimiento : getEndDate(),
            fecha_creacion: edit ? editItem.fecha_creacion : moment().format('YYYY-MM-DD'),
            estatus: edit
              ? editItem.estatus
              : statuss &&
                statuss.data.find((e) => e.nombre.toLowerCase() === "abierto")
              ? statuss.data.find((e) => e.nombre.toLowerCase() === "abierto")
                  .id
              : "",
            // numero_ticket: edit ? editItem.numero_ticket : obtenerTextoCDT(),
            // numero_ticket: edit ? generarCodigo() : "",
            numero_ticket:
              edit && editItem.numero_ticket ? editItem.numero_ticket : "",
            creado_por: edit ? editItem.creado_por : userId,
            id_workflow: edit ? editItem.id_workflow : "",
            id_responsable_off: edit ? editItem.id_responsable_off : "",
            categoria_desvinculacion: edit
              ? editItem.categoria_desvinculacion
              : "",
            comentarios: edit ? editItem.comentarios : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit
                    ? "Editar caso disciplinario"
                    : "Crear caso disciplinario"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {formDisciplinaryCaseFaild &&
                typeof formDisciplinaryCaseFaild !== "object" ? (
                  <Alert variant="danger" className="mt-4 mb-2">
                    {formDisciplinaryCaseFaild}
                  </Alert>
                ) : null}
                {/* <Row className="align-items-end">
                <Col sm={ loaderAllEmployees ? 10 : 12}>
                  <Form.Label className="ml-1">Empleado</Form.Label>
                  <Typeahead
                    id="codigo_empleado"
                    name="codigo_empleado"
                    isInvalid={touched.codigo_empleado && !!errors.codigo_empleado}
                    placeholder="Empleado"
                    options={usersOptions}
                    onChange={selected => { setFieldValue('codigo_empleado', selected.length > 0 ? selected[0].id : ''); setUserSelected(selected);}} 
                    selected={userSelected} >
                  </Typeahead>
                  {
                    errors.codigo_empleado && (
                      <div>
                        <small className="text-danger">{errors.codigo_empleado}</small> 
                      </div>
                    )
                  }
                  {
                    formDisciplinaryCaseFaild && typeof formDisciplinaryCaseFaild === 'object' && formDisciplinaryCaseFaild.codigo_empleado ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {
                          formDisciplinaryCaseFaild.codigo_empleado.map( item => (
                            <li>{item}</li>
                          ))
                        }
                      </ul>
                    ) : null
                  }
                </Col>
                {
                  loaderAllEmployees && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )
                }
              </Row> */}
                <Form.Control
                  name="codigo_empleado"
                  className="rounded-pill"
                  type="hidden"
                  defaultValue={values.codigo_empleado}
                  isValid={touched.codigo_empleado && !errors.codigo_empleado}
                  isInvalid={
                    touched.codigo_empleado && !!errors.codigo_empleado
                  }
                ></Form.Control>
                <Form.Group className="mb-3 align-items-end d-flex">
                  <div className="flex-grow-1">
                    <Form.Label className="ml-2">Empleado</Form.Label>
                    <Form.Control
                      className="rounded-pill"
                      readOnly
                      required
                      type="text"
                      value={
                        userSelected
                          ? `${userSelected.codigo} ${userSelected.nombre}`
                          : ""
                      }
                      placeholder="Empleado"
                      isInvalid={!!errors.codigo_empleado}
                    ></Form.Control>
                    <Form.Control.Feedback className="mx-2" type="invalid">
                      {errors.codigo_empleado}
                    </Form.Control.Feedback>
                    {formDisciplinaryCaseFaild &&
                    typeof formDisciplinaryCaseFaild === "object" &&
                    formDisciplinaryCaseFaild.codigo_empleado ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formDisciplinaryCaseFaild.codigo_empleado.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </div>
                  <OverlayTrigger
                    placement="auto"
                    overlay={
                      <Tooltip
                        {...props}
                        style={{ zIndex: "99999999999999999999999999" }}
                      >
                        Seleccionar empleado
                      </Tooltip>
                    }
                  >
                    <Button
                      onClick={() => setShowModalUser(true)}
                      variant="light"
                      className="rounded-circle ml-2"
                      style={{
                        marginBottom: errors.codigo_empleado ? "1.3rem" : 0,
                      }}
                      size="sm"
                      disabled={edit ? editItem.fecha_cierre : false}
                    >
                      <i className="material-icons">group</i>
                    </Button>
                  </OverlayTrigger>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Caso disciplinario
                  </Form.Label>
                  <Form.Control
                    name="caso_disciplinario"
                    className="rounded-pill"
                    required
                    type="text"
                    defaultValue={values.caso_disciplinario}
                    placeholder="Caso disciplinario"
                    onBlur={handleBlur("caso_disciplinario")}
                    onChange={(e) => handleChange(e)}
                    isValid={
                      touched.caso_disciplinario && !errors.caso_disciplinario
                    }
                    isInvalid={
                      touched.caso_disciplinario && !!errors.caso_disciplinario
                    }
                    disabled={edit ? editItem.fecha_cierre : false}
                  ></Form.Control>
                  <Form.Control.Feedback className="mx-2" type="invalid">
                    {errors.caso_disciplinario}
                  </Form.Control.Feedback>
                  {formDisciplinaryCaseFaild &&
                  typeof formDisciplinaryCaseFaild === "object" &&
                  formDisciplinaryCaseFaild.caso_disciplinario ? (
                    <ul className="list-unstyled text-danger ml-2">
                      {formDisciplinaryCaseFaild.caso_disciplinario.map(
                        (item) => (
                          <li>{item}</li>
                        )
                      )}
                    </ul>
                  ) : null}
                </Form.Group>
                <Row className="d-flex align-items-center mt-2">
                  <Form.Group
                    as={Col}
                    sm={loadingDisciplinaryActionType ? 11 : 12}
                    controlId="diciplinaryActionType"
                  >
                    <Form.Label className="ml-2">
                      Tipo de acción disciplinaria
                    </Form.Label>
                    <Typeahead
                      id="id_accion_disciplinaria"
                      name="id_accion_disciplinaria"
                      isValid={
                        touched.id_accion_disciplinaria &&
                        !errors.id_accion_disciplinaria
                      }
                      isInvalid={
                        touched.id_accion_disciplinaria &&
                        !!errors.id_accion_disciplinaria
                      }
                      placeholder="Tipo de acción disciplinaria"
                      options={actioTypeOptions}
                      onBlur={handleBlur("id_accion_disciplinaria")}
                      onChange={(selected) => {
                        setFieldValue(
                          "id_accion_disciplinaria",
                          selected.length > 0 ? selected[0].id : ""
                        );
                        setActionSelected(selected);
                      }}
                      selected={actionSelected}
                      disabled={edit ? editItem.fecha_cierre : false}
                    ></Typeahead>
                    {/* <Form.Control
                      as="select"
                      name="id_accion_disciplinaria"
                      className="rounded-pill"
                      required
                      value={values.id_accion_disciplinaria}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.id_accion_disciplinaria &&
                        !!errors.id_accion_disciplinaria
                      }
                      disabled={edit ? editItem.fecha_cierre : false}
                    >
                      <option disabled value="">
                        Selec...
                      </option>
                      {disciplinaryActionTypes.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.descripcion}
                        </option>
                      ))}
                    </Form.Control> */}
                    {touched.id_accion_disciplinaria &&
                      errors.id_accion_disciplinaria && (
                        <small className="mx-2 text-danger">
                          {errors.id_accion_disciplinaria}
                        </small>
                      )}
                    {formDisciplinaryCaseFaild &&
                    typeof formDisciplinaryCaseFaild === "object" &&
                    formDisciplinaryCaseFaild.id_accion_disciplinaria ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formDisciplinaryCaseFaild.id_accion_disciplinaria.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </Form.Group>
                  {loadingDisciplinaryActionType && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
                <Row className="d-flex align-items-center mt-1">
                  <Form.Group
                    as={Col}
                    sm={loadingDisciplinaryAction ? 11 : 12}
                    controlId="disciplinaryReason"
                  >
                    <Form.Label className="ml-2">Motivo del caso</Form.Label>
                    <Typeahead
                      id="id_motivo"
                      name="id_motivo"
                      isValid={touched.id_motivo && !errors.id_motivo}
                      isInvalid={touched.id_motivo && !!errors.id_motivo}
                      placeholder="Motivo del caso"
                      options={motiveOptions}
                      onBlur={handleBlur("id_motivo")}
                      onChange={(selected) => {
                        setFieldValue(
                          "id_motivo",
                          selected.length > 0 ? selected[0].id : ""
                        );
                        setMotiveSelected(selected);
                      }}
                      selected={motiveSelected}
                      disabled={edit ? editItem.fecha_cierre : false}
                    ></Typeahead>
                    {/* <Form.Control
                      as="select"
                      name="id_motivo"
                      className="rounded-pill"
                      required
                      value={values.id_motivo}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.id_motivo && !!errors.id_motivo}
                      disabled={edit ? editItem.fecha_cierre : false}
                    >
                      <option disabled value="">
                        Selec...
                      </option>
                      {disciplinaryAction.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nombre}
                        </option>
                      ))}
                    </Form.Control> */}
                    {/* <Form.Control.Feedback type="invalid">
                      {errors.id_motivo}
                    </Form.Control.Feedback> */}
                    {touched.id_motivo && errors.id_motivo && (
                      <small className="mx-2 text-danger">
                        {errors.id_motivo}
                      </small>
                    )}
                    {formDisciplinaryCaseFaild &&
                    typeof formDisciplinaryCaseFaild === "object" &&
                    formDisciplinaryCaseFaild.id_motivo ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formDisciplinaryCaseFaild.id_motivo.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  {loadingDisciplinaryAction && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
                <Row className="align-items-end mt-1 mb-3">
                  <Col sm={responsableLoading ? 10 : 12}>
                    <Form.Label className="ml-2">Encargado</Form.Label>
                    <Typeahead
                      id="id_encargado"
                      name="id_encargado"
                      isValid={touched.id_encargado && !errors.id_encargado}
                      isInvalid={touched.id_encargado && !!errors.id_encargado}
                      placeholder="Encargado"
                      options={responsableOptions}
                      onBlur={handleBlur("id_encargado")}
                      onChange={(selected) => {
                        setFieldValue(
                          "id_encargado",
                          selected.length > 0 ? selected[0].id : ""
                        );
                        setRespSelected(selected);
                      }}
                      selected={respSelected}
                      disabled={edit ? editItem.fecha_cierre : false}
                    ></Typeahead>

                    {touched.id_encargado && errors.id_encargado && (
                      <small className="mx-2 text-danger">
                        {errors.id_encargado}
                      </small>
                    )}
                    {formDisciplinaryCaseFaild &&
                    typeof formDisciplinaryCaseFaild === "object" &&
                    formDisciplinaryCaseFaild.id_encargado ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formDisciplinaryCaseFaild.id_encargado.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Col>
                  {responsableLoading && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
                <Form.Group className="mb-3 mt-2">
                  <Form.Label className="ml-2">Fecha de vencimiento</Form.Label>
                  <Form.Control
                    className="rounded-pill"
                    name="fecha_vencimiento"
                    type="date"
                    disabled
                    placeholder="Fecha de inicio"
                    onBlur={handleBlur("fecha_vencimiento")}
                    defaultValue={values.fecha_vencimiento}
                    onChange={(e) => handleChange(e)}
                    isValid={
                      touched.fecha_vencimiento && !errors.fecha_vencimiento
                    }
                    isInvalid={
                      touched.fecha_vencimiento && !!errors.fecha_vencimiento
                    }
                  />
                  <Form.Control.Feedback className="mx-2" type="invalid">
                    {errors.fecha_vencimiento}
                  </Form.Control.Feedback>
                  {formDisciplinaryCaseFaild &&
                  typeof formDisciplinaryCaseFaild === "object" &&
                  formDisciplinaryCaseFaild.fecha_vencimiento ? (
                    <ul className="list-unstyled text-danger ml-2">
                      {formDisciplinaryCaseFaild.fecha_vencimiento.map(
                        (item) => (
                          <li>{item}</li>
                        )
                      )}
                    </ul>
                  ) : null}
                </Form.Group>
                <Form.Group className="mb-3 mt-2">
                  <Form.Label className="ml-2">Fecha de creación</Form.Label>
                  <Form.Control
                    className="rounded-pill"
                    name="fecha_creacion"
                    type="date"
                    disabled={edit}
                    placeholder="Fecha de creación"
                    onBlur={handleBlur("fecha_creacion")}
                    defaultValue={values.fecha_creacion}
                    onChange={(e) => handleChange(e)}
                    isValid={
                      touched.fecha_creacion && !errors.fecha_creacion
                    }
                    isInvalid={
                      touched.fecha_creacion && !!errors.fecha_creacion
                    }
                  />
                  <Form.Control.Feedback className="mx-2" type="invalid">
                    {errors.fecha_creacion}
                  </Form.Control.Feedback>
                  {formDisciplinaryCaseFaild &&
                  typeof formDisciplinaryCaseFaild === "object" &&
                  formDisciplinaryCaseFaild.fecha_creacion ? (
                    <ul className="list-unstyled text-danger ml-2">
                      {formDisciplinaryCaseFaild.fecha_creacion.map(
                        (item) => (
                          <li>{item}</li>
                        )
                      )}
                    </ul>
                  ) : null}
                </Form.Group>
                <Row className="align-items-end mt-2">
                  <Form.Group
                    as={Col}
                    sm={loadingFoulType ? 11 : 12}
                    controlId="foulType"
                  >
                    <Form.Label className="ml-2">Tipo de falta</Form.Label>
                    <Form.Control
                      as="select"
                      name="id_tipo_falta"
                      className="rounded-pill"
                      required
                      value={values.id_tipo_falta}
                      onBlur={handleBlur("id_tipo_falta")}
                      onChange={(e) => handleChange(e)}
                      isValid={touched.id_tipo_falta && !errors.id_tipo_falta}
                      isInvalid={
                        touched.id_tipo_falta && !!errors.id_tipo_falta
                      }
                      disabled={edit ? editItem.fecha_cierre : false}
                    >
                      <option disabled value="">
                        Selec...
                      </option>
                      {foulType.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.descripcion}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback className="mx-2" type="invalid">
                      {errors.id_tipo_falta}
                    </Form.Control.Feedback>
                    {formDisciplinaryCaseFaild &&
                    typeof formDisciplinaryCaseFaild === "object" &&
                    formDisciplinaryCaseFaild.id_tipo_falta ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formDisciplinaryCaseFaild.id_tipo_falta.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  {loadingFoulType && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
                <Row className="align-items-end">
                  <Form.Group
                    as={Col}
                    sm={loaderStatuss ? 11 : 12}
                    controlId="statusSan"
                  >
                    <Form.Label className="ml-2">Estatus</Form.Label>
                    <Form.Control
                      as="select"
                      name="estatus"
                      className="rounded-pill"
                      required
                      value={values.estatus}
                      onBlur={handleBlur("estatus")}
                      onChange={(e) => handleChange(e)}
                      isValid={touched.estatus && !errors.estatus}
                      isInvalid={touched.estatus && !!errors.estatus}
                      disabled={edit ? editItem.fecha_cierre : true}
                    >
                      <option disabled value="">
                        Selec...
                      </option>
                      {statuss && statuss.data.length > 0
                        ? statuss.data.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback className="mx-2" type="invalid">
                      {errors.estatus}
                    </Form.Control.Feedback>
                    {formDisciplinaryCaseFaild &&
                    typeof formDisciplinaryCaseFaild === "object" &&
                    formDisciplinaryCaseFaild.estatus ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formDisciplinaryCaseFaild.estatus.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  {loaderStatuss && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
                <Form.Group className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Número de ticket
                  </Form.Label>
                  <Form.Control
                    name="numero_ticket"
                    className="rounded-pill"
                    //modifique aqui
                    type="text"
                    value={values.numero_ticket}
                    onBlur={handleBlur("numero_ticket")}
                    onChange={(e) => handleChange(e)}
                    isValid={touched.numero_ticket && !errors.numero_ticket}
                    isInvalid={touched.numero_ticket && !!errors.numero_ticket}
                    disabled
                  ></Form.Control>
                  <Form.Control.Feedback className="mx-2" type="invalid">
                    {errors.numero_ticket}
                  </Form.Control.Feedback>
                  {formDisciplinaryCaseFaild &&
                  typeof formDisciplinaryCaseFaild === "object" &&
                  formDisciplinaryCaseFaild.numero_ticket ? (
                    <ul className="list-unstyled text-danger ml-2">
                      {formDisciplinaryCaseFaild.numero_ticket.map((item) => (
                        <li>{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Descripción:
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    required
                    name="descripcion"
                    defaultValue={values.descripcion}
                    onBlur={handleBlur("descripcion")}
                    onChange={(e) => handleChange(e)}
                    isValid={touched.descripcion && !errors.descripcion}
                    isInvalid={touched.descripcion && !!errors.descripcion}
                    placeholder="Descripción"
                    disabled={edit ? editItem.fecha_cierre : false}
                  ></Form.Control>
                  <Form.Control.Feedback className="mx-2" type="invalid">
                    {errors.descripcion}
                  </Form.Control.Feedback>
                  {formDisciplinaryCaseFaild &&
                  typeof formDisciplinaryCaseFaild === "object" &&
                  formDisciplinaryCaseFaild.descripcion ? (
                    <ul className="list-unstyled text-danger ml-2">
                      {formDisciplinaryCaseFaild.descripcion.map((item) => (
                        <li>{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </Form.Group>
                {view === "Responsable_Sanciones" ||
                view === "Encargado_Sanciones" ||
                view === "administrador" ? (
                  // userRoles.length > 0 &&
                  //   (userRoles.includes("Responsable_Sanciones") ||
                  //     userRoles.includes("Encargado_Sanciones") ||
                  //     userRoles.includes("administrador"))
                  <>
                    {((edit && !editItem.list_id_usuario) ||
                      (data && data.length === 0)) && (
                      <Alert variant="danger" className="mt-4 mb-1">
                        No se puede crear workflow porque el empleado no tiene
                        un usuario creado.
                      </Alert>
                    )}
                    {edit && editItem.off_bording && (
                      <Alert variant="danger" className="mt-4 mb-1">
                        El usuario ya se encuentra en un workflow de este tipo
                      </Alert>
                    )}
                    <Row className="align-items-end mb-1 mt-2">
                      <Form.Group
                        as={Col}
                        sm={loadingAuth ? 11 : 12}
                        controlId="workflowTemplate"
                      >
                        <Form.Label className="ml-2">
                          Plantilla de workflow
                        </Form.Label>
                        <Row>
                          <Col sm={loadingWorkFlow ? 11 : 12}>
                            <Typeahead
                              id="id_workflow"
                              name="id_workflow"
                              isValid={
                                touched.id_workflow && !errors.id_workflow
                              }
                              isInvalid={
                                touched.id_workflow && !!errors.id_workflow
                              }
                              placeholder="plantilla de workflow"
                              options={templateOptions}
                              onBlur={handleBlur("id_workflow")}
                              onChange={(selected) => {
                                setFieldValue(
                                  "id_workflow",
                                  selected.length > 0 ? selected[0].id : ""
                                );
                                setTempSelected(selected);
                              }}
                              disabled={
                                (edit && !editItem.list_id_usuario) ||
                                (edit && editItem.off_bording !== null) ||
                                (data && data.length === 0) ||
                                (edit && editItem.fecha_cierre)
                              }
                              selected={tempSelected}
                            ></Typeahead>
                          </Col>
                          {loadingWorkFlow && (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                        {touched.id_workflow && errors.id_workflow && (
                          <small className="mx-2 text-danger">
                            {errors.id_workflow}
                          </small>
                        )}
                        {/* {isTempValid && (
                      <div>
                        <small className="text-danger">**Campo requerido</small>
                      </div>
                    )} */}
                      </Form.Group>
                      {loadingAuth && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    <Row className="align-items-end mb-1 mt-2">
                      <Form.Group
                        as={Col}
                        sm={loadingAuth ? 11 : 12}
                        controlId="offboardingResp"
                      >
                        <Form.Label className="ml-2">
                          Responsable de OffBoarding
                        </Form.Label>
                        <Row>
                          <Col sm={responsablesOtroLoading ? 11 : 12}>
                            <Typeahead
                              id="id_responsable_off"
                              name="id_responsable_off"
                              isValid={
                                touched.id_responsable_off &&
                                !errors.id_responsable_off
                              }
                              isInvalid={
                                touched.id_responsable_off &&
                                !!errors.id_responsable_off
                              }
                              placeholder="Responsable de offboarding"
                              options={responsableBoardingOptions}
                              onBlur={handleBlur("id_responsable_off")}
                              onChange={(selected) => {
                                setFieldValue(
                                  "id_responsable_off",
                                  selected.length > 0 ? selected[0].id : ""
                                );
                                setRespOtroSelected(selected);
                              }}
                              disabled={
                                (edit && !editItem.list_id_usuario) ||
                                (edit && editItem.off_bording !== null) ||
                                (data && data.length === 0) ||
                                (edit && editItem.fecha_cierre)
                              }
                              selected={respOtroSelected}
                            ></Typeahead>
                          </Col>
                          {responsablesOtroLoading && (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                        {touched.id_responsable_off &&
                          errors.id_responsable_off && (
                            <small className="mx-2 text-danger">
                              {errors.id_responsable_off}
                            </small>
                          )}
                      </Form.Group>
                      {loadingAuth && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    <Form.Group>
                      <Form.Label column sm="12" md="12">
                        Categoria de desvinculación
                      </Form.Label>
                      <Row>
                        <Col sm={loadingUnlinkCategories ? 11 : 12}>
                          <Typeahead
                            id="categoria_desvinculacion"
                            name="categoria_desvinculacion"
                            isValid={
                              touched.categoria_desvinculacion &&
                              !errors.categoria_desvinculacion
                            }
                            isInvalid={
                              touched.categoria_desvinculacion &&
                              !!errors.categoria_desvinculacion
                            }
                            placeholder="Categoria de desvinculación"
                            options={categoryOptions}
                            onBlur={handleBlur("categoria_desvinculacion")}
                            onChange={(selected) => {
                              setFieldValue(
                                "categoria_desvinculacion",
                                selected.length > 0 ? selected[0].id : ""
                              );
                              setCatSelected(selected);
                            }}
                            selected={catSelected}
                            disabled={
                              edit
                                ? editItem.fecha_cierre
                                : // ||
                                  //   (userRoles.length > 0 &&
                                  //     !(
                                  //       userRoles.includes(
                                  //         "Responsable_Sanciones"
                                  //       ) ||
                                  //       userRoles.includes(
                                  //         "Encargado_Sanciones"
                                  //       ) ||
                                  //       userRoles.includes("administrador")
                                  //     ))
                                  false
                            }
                          ></Typeahead>
                        </Col>
                        {loadingUnlinkCategories && (
                          <Col sm={1}>
                            <Spinner animation="border" size="sm" />
                          </Col>
                        )}
                      </Row>
                      {touched.categoria_desvinculacion &&
                        errors.categoria_desvinculacion && (
                          <small className="mx-2 text-danger">
                            {errors.categoria_desvinculacion}
                          </small>
                        )}
                      {/* {isCategoryValid && (
                    <div>
                      <small className="text-danger">**Campo requerido</small>
                    </div>
                  )} */}
                    </Form.Group>

                    {/* <Form.Group className="mb-1">
                      <Form.Label column sm="12" md="12">
                        Archivos
                      </Form.Label>
                      <Row>
                        <Col>
                          <Form.File
                            multiple
                            id="archivo"
                            name="archivo"
                            className="col position-relative my-2"
                            // disabled={
                            //   edit &&
                            //   editItem.list_estado[0].nombre_estado.toLowerCase() ===
                            //     "cerrado"
                            // }
                            value={values.archivo}
                            onBlur={handleBlur("archivo")}
                            onChange={handleChange}
                            // onBlur={handleBlur("plan_induccion")}
                            isValid={touched.archivo && !errors.archivo}
                            isInvalid={touched.archivo && !!errors.archivo}
                          />
                        </Col>
                      </Row>
                      {touched.archivo && errors.archivo && (
                        <small className="mx-2 text-danger">
                          {errors.archivo}
                        </small>
                      )}
                    </Form.Group> */}
                  </>
                ) : null}
                <Form.Group className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Archivos
                  </Form.Label>
                  <Row>
                    <Col>
                      <Form.File
                        multiple
                        id="archivo"
                        name="archivo"
                        className="col position-relative my-2"
                        // disabled={
                        //   edit &&
                        //   editItem.list_estado[0].nombre_estado.toLowerCase() ===
                        //     "cerrado"
                        // }
                        value={values.archivo}
                        onBlur={handleBlur("archivo")}
                        onChange={handleChange}
                        // onBlur={handleBlur("plan_induccion")}
                        isValid={touched.archivo && !errors.archivo}
                        isInvalid={touched.archivo && !!errors.archivo}
                      />
                    </Col>
                  </Row>
                  {touched.archivo && errors.archivo && (
                    <small className="mx-2 text-danger">{errors.archivo}</small>
                  )}
                  {edit &&
                    editItem.list_sanciones_casos_disciplinarios_archivos &&
                    editItem.list_sanciones_casos_disciplinarios_archivos
                      .length > 0 && (
                      <>
                        <Col>
                          <hr />
                          <Row>
                            <Col sm={3}>
                              <p className="text-muted">Documentos actuales</p>
                            </Col>
                            <Col sm={9}>
                              <Row>
                                <Col>
                                  <ul className="list-unstyled">
                                    {editItem.list_sanciones_casos_disciplinarios_archivos.map(
                                      (url, _index) => (
                                        <>
                                          <li
                                            key={editItem.id}
                                            className="d-flex align-items-center"
                                          >
                                            <Button
                                              size="sm"
                                              className="mx-3 text-info"
                                              variant="link"
                                              type="button"
                                              onClick={() => {
                                                setDownloadEdit(
                                                  parseInt(index)
                                                );
                                                setTimeout(() => {
                                                  var element =
                                                    document.createElement("a");
                                                  element.setAttribute(
                                                    "href",
                                                    // "data:text/plain;charset=utf-8," +
                                                    // encodeURIComponent(
                                                    `${process.env.REACT_APP_URL}/media/${url.archivo}`
                                                    // )
                                                  );
                                                  element.setAttribute(
                                                    "download",
                                                    `${url.nombre_archivo}`
                                                  );
                                                  element.style.display =
                                                    "none";
                                                  document.body.appendChild(
                                                    element
                                                  );
                                                  element.click();
                                                  document.body.removeChild(
                                                    element
                                                  );
                                                  setDownloadEdit(null);
                                                }, 500);
                                              }}
                                            >
                                              {downloadEdit !== null &&
                                              parseInt(downloadEdit) ===
                                                parseInt(index) ? (
                                                <Spinner
                                                  animation="border"
                                                  size="sm"
                                                />
                                              ) : (
                                                url.nombre_archivo
                                              )}
                                            </Button>
                                            {/* <Button
                                            size="sm"
                                            className="text-danger"
                                            variant="link"
                                            type="button"
                                            onClick={() =>
                                              onDeleteUrl(url.id, index, _index)
                                            }
                                          >
                                            <i className="material-icons">
                                              close
                                            </i>
                                          </Button> */}
                                          </li>
                                        </>
                                      )
                                    )}
                                  </ul>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </>
                    )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Comentarios:
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    name="comentarios"
                    defaultValue={values.comentarios}
                    onBlur={handleBlur("comentarios")}
                    onChange={(e) => handleChange(e)}
                    isValid={touched.comentarios && !errors.comentarios}
                    isInvalid={touched.comentarios && !!errors.comentarios}
                    placeholder="Nuevo comentario"
                    disabled={edit && editItem.fecha_cierre}
                  ></Form.Control>
                  <Form.Control.Feedback className="mx-2" type="invalid">
                    {errors.comentarios}
                  </Form.Control.Feedback>

                  {formDisciplinaryCaseFaild &&
                  typeof formDisciplinaryCaseFaild === "object" &&
                  formDisciplinaryCaseFaild.comentarios ? (
                    <ul className="list-unstyled text-danger ml-2">
                      {formDisciplinaryCaseFaild.comentarios.map(
                        (item, index) => (
                          <li key={index}>{item}</li>
                        )
                      )}
                    </ul>
                  ) : null}

                  {edit && (
                    <>
                      {/* Línea divisoria y sección de ícono y texto */}
                      <div className="d-flex align-items-center mt-4 mb-3">
                        <hr className="flex-grow-1" /> {/* Línea divisoria */}
                        <div className="d-flex align-items-center ms-3">
                          <Button
                            variant="link"
                            className="p-0 mx-1"
                            onClick={() => setShowComments(!showComments)}
                          >
                            <FaCommentDots size={20} /> {/* Ícono */}
                            <span className="text-muted">
                              {showComments
                                ? "Ocultar Comentarios"
                                : "Mostrar Comentarios"}
                            </span>
                          </Button>
                        </div>
                      </div>

                      {showComments &&
                        (comments && comments.comentarios.length > 0 ? (
                          <ComentariosList comentarios={comments.comentarios} />
                        ) : (
                          <Alert variant="info" className="mt-3">
                            No hay comentarios para mostrar.
                          </Alert>
                        ))}
                    </>
                  )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                {/* {userRoles.length > 0 &&
                  (userRoles.includes("Responsable_Sanciones") ||
                    userRoles.includes("Encargado_Sanciones") ||
                    userRoles.includes("administrador")) && ( */}
                {!edit || (edit && !editItem.fecha_cierre) ? (
                  <>
                    <Button
                      className="rounded-pill"
                      disabled={
                        saveLoaderDiciplinaryCase ||
                        (edit && editItem.fecha_cierre)
                      }
                      variant="primary"
                      type="submit"
                    >
                      {saveLoaderDiciplinaryCase && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  </>
                ) : null}
              </Modal.Footer>
              <Modal
                show={showModalUser}
                onHide={() => setShowModalUser(false)}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Buscar empleado</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row className="justify-content-end align-items-center flex-nowrap">
                    <Col xs="auto">
                      <Form.Label className="m-0" htmlFor="filterEmployee">
                        <b>{tipoBusquedaEmployee.desc}:</b>
                      </Form.Label>
                    </Col>
                    <Col xs="auto">
                      <Form.Control
                        id="filterEmployee"
                        name="filterEmployee"
                        placeholder="Buscar empleado"
                        required
                        className={`rounded-pill form-control-sm ${
                          validatedEmployee ? "is-invalid" : ""
                        }`}
                        type="search"
                        onKeyDown={onSearchEmployee}
                        //value={searchEmployee}
                        //onChange={e => setSearchEmployee(e.target.value)}
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        **Campo requerido
                      </Form.Control.Feedback>
                    </Col>
                    <Col>
                      <ButtonGroup>
                        <OverlayTrigger
                          placement="auto"
                          overlay={
                            <Tooltip
                              {...props}
                              style={{ zIndex: "99999999999999999999999999" }}
                            >
                              Seleccionar Filtrado
                            </Tooltip>
                          }
                        >
                          <Dropdown className="ml-3 mr-3">
                            <Dropdown.Toggle
                              variant="light"
                              className="btn-sm font rounded-pill"
                            >
                              <i className="material-icons">filter_list</i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {filtersEmployees.map((item) => (
                                <Dropdown.Item
                                  onClick={() => setTipoBusquedaEmployee(item)}
                                  key={item.id}
                                >
                                  {item.desc}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </OverlayTrigger>
                      </ButtonGroup>
                    </Col>
                  </Row>
                  <div className="my-3">
                    {employeesFaild ? (
                      <Alert variant="danger" className="my-4">
                        {employeesFaild}
                      </Alert>
                    ) : null}
                    {loaderAllEmployees ? (
                      <div className="d-flex justify-content-center">
                        <Spinner
                          animation="border"
                          role="status"
                          className="d-flex justify-content-center"
                        />
                      </div>
                    ) : employees.length > 0 ? (
                      <ListGroup variant="flush">
                        {employees.map((employee) => (
                          <ListGroup.Item className="d-flex flex-wrap justify-content-between align-items-center">
                            <p className="m-0">
                              {employee.codigo} {employee.nombre}
                            </p>
                            <Button
                              onClick={() => {
                                handleUserAdd(
                                  employee,
                                  setFieldValue,
                                  values.numero_ticket
                                );
                                dispatch(getUsers({ filter: employee.codigo }));
                              }}
                              size="sm"
                              variant="light"
                              className="rounded-circle"
                            >
                              <i className="material-icons">person_add</i>
                            </Button>
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    ) : (
                      <>
                        {!employeesFaild && (
                          <Alert variant="info" className="my-4">
                            Sin registros que mostrar.
                          </Alert>
                        )}
                      </>
                    )}
                  </div>
                </Modal.Body>
                {/* <Modal.Footer>
                <Button size="sm" className="rounded-pill" variant="secondary" onClick={() => setShowModalUser(false)}>
                  Close
                </Button>
                <Button 
                  size="sm" 
                  className="rounded-pill" 
                  variant="primary" onClick={() => setFieldValue('codigo_empleado','3243242')}>
                  Save Changes
                </Button>
              </Modal.Footer> */}
              </Modal>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Disciplinary_Case;
